import { render, staticRenderFns } from "./AdvertisementAudio.vue?vue&type=template&id=9b89a204&scoped=true"
import script from "./AdvertisementAudio.vue?vue&type=script&lang=js"
export * from "./AdvertisementAudio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b89a204",
  null
  
)

export default component.exports